// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-1b10c1f5]{text-align:left}.modal-wrapper[data-v-1b10c1f5]{overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
